import { peopleData } from './peopleData'

const uniquePositions = Array.from(new Set(peopleData.map((person) => person.currentPosition)))

export const jobData = uniquePositions.map((position, index) => {
  return {
    id: index + 1,
    jobTitle: position,
    description: `This is a detailed description for the position of ${position}. The role involves various responsibilities and requires specific skills and experience. Candidates should be prepared to handle multiple tasks and work collaboratively with the team. The position offers opportunities for growth and development within the company. Applicants should have a strong background in relevant fields and demonstrate a commitment to excellence.`,
    level: position.includes('Senior') ? 'Senior' : position.includes('Junior') ? 'Junior' : 'Mid',
    skills: ['Skill1', 'Skill2', 'Skill3'], // Placeholder skills for now
    actions: '',
  }
})
